
<div class="d-flex flex-column gap-2">
  <app-set-user-password></app-set-user-password>
  <app-failed-logins></app-failed-logins>
</div>




// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/auth-tools.component.html